export default __webpack_public_path__ + "static/media/supplementary-major-medical-icon.da1440cb.svg";